export default __webpack_public_path__ + "static/media/icon-coin-xtz.d8f31471.svg";